import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLElement> {
  static targets = ["button", "body", "closedIcon", "openIcon"];

  declare readonly buttonTarget: HTMLButtonElement;
  declare readonly bodyTarget: HTMLElement;
  declare readonly closedIconTarget: HTMLElement;
  declare readonly openIconTarget: HTMLElement;

  private open = false;
  private desktopQuery?: MediaQueryList;

  connect() {
    this.desktopQuery = window.matchMedia("(min-width: 1024px)");
    this.render();

    if ("addEventListener" in this.desktopQuery) {
      this.desktopQuery.addEventListener("change", this.render);
    } else {
      this.desktopQuery.addListener(this.render);
    }
  }

  disconnect() {
    if (!this.desktopQuery) return;

    if ("removeEventListener" in this.desktopQuery) {
      this.desktopQuery.removeEventListener("change", this.render);
    } else {
      this.desktopQuery.removeListener(this.render);
    }
  }

  toggle() {
    this.open = !this.open;
    this.render();
  }

  close() {
    this.open = false;
    this.render();
  }

  private render = () => {
    this.buttonTarget.setAttribute("aria-expanded", String(this.open));
    this.closedIconTarget.classList.toggle("hidden", this.open);
    this.openIconTarget.classList.toggle("hidden", !this.open);

    if (this.desktopQuery?.matches) {
      this.bodyTarget.classList.remove("hidden");
      return;
    }

    this.bodyTarget.classList.toggle("hidden", !this.open);
  };
}
